<template>
    <div class="form-group">
        <label v-if="title && title.trim().length > 0">
            {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <div class="col-12" v-if="!isReadOnly">
            <div class="form-group">
                <div class="btn btn-default btn-file" :class="{ 'border-danger': error || fileLimitError }">
                    <i class="fas fa-paperclip"></i> Thêm tập tin
                    <input type="file" name="attachment" :multiple="isMultiple" @change="onChooseFile">
                </div>
                <span class="help-block font-italic ml-2">(Tối đa: {{ maxSize }}MB)</span>
            </div>
        </div>
        <div class="col-12 list-files">
            <div v-for="(file, index) in files" :key="index" class="file-item clearfix mb-1">
                <a :href="file.fileId ? file.downloadLink : file.tempUrl" class="popup-link">
                    <img :src="file.fileId ? file.downloadLink : file.tempUrl" class="image-thumb img-fluid">
                </a>
                <div class="file-details">
                    <span class="text-primary">{{ file.name || file.fileName }}</span>
                    <div class="file-actions">
                        <a :href="file.fileId ? file.downloadLink : file.tempUrl" target="_blank">
                            <i class="fas fa-download text-primary text-bold" title="Download file"></i>
                        </a>
                        <i v-if="!isReadOnly" class="fas fa-times text-danger text-bold remove-icon"
                            @click="onRemoveFile(index)" title="Remove file"></i>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="fileLimitError" class="text-danger mb-2">{{ fileLimitError }}</div>
        <div class="text-danger text-right mb-2" style="margin-top: -13px !important;" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted, nextTick } from "vue";
import { mapActions } from 'vuex';
import config from '@/config/prod.env';
import TheSuaChuaTruDenChieuSang from "../hethongchieusang/TheSuaChuaTruDenChieuSang.vue";

export default {
    name: "TheFilePicker",
    props: {
        title: String,
        initialValue: Array,
        error: String,
        isReadOnly: Boolean,
        isRequire: Boolean,
        isMultiple: Boolean,
        maxFiles: {
            type: Number,
            default: null, // Default max file count if not provided
        },
        maxSize: {
            type: Number,
            default: 30,
            required: false,
        }
    },
    data() {
        return {
            API_URL: config.API_URL,
            files: [],
            addedFiles: [], // Mảng lưu file mới được thêm
            deletedFiles: [], // Mảng lưu file đã xóa
            fileLimitError: null,
        }
    },
    methods: {
        ...mapActions('file', ['downloadFile', 'deleteFile']),

        createTempUrl(file) {
            file.tempUrl = URL.createObjectURL(file);
            return file.tempUrl;
        },

        async onChooseFile(e) {
            const selectedFiles = Array.from(e.target.files);

            if (!this.isMultiple) {
                this.clearTempUrls();
                this.files = [];
                this.addedFiles = [];
            }

            // Check if adding new files exceeds the limit
            if (this.maxFiles) {
                const totalFiles = this.files.length + selectedFiles.length;
                if (this.isMultiple && totalFiles > this.maxFiles) {
                    this.fileLimitError = `Bạn chỉ có thể thêm tối đa ${this.maxFiles} tập tin.`;
                    return;
                }
                this.fileLimitError = null; // Clear any previous error
            }

            selectedFiles.forEach(file => {
                file.tempUrl = this.createTempUrl(file);
                this.files.push(file);

                if (!this.addedFiles.some(f => f.name === file.name && f.size === file.size)) {
                    this.addedFiles.push(file);
                }
            });

            this.emitChange();
            this.initializePopup();
        },

        onRemoveFile(index) {
            const removedFile = this.files.splice(index, 1)[0];

            if (removedFile.tempUrl) {
                URL.revokeObjectURL(removedFile.tempUrl);
            }

            // Kiểm tra xem file có nằm trong addedFiles không
            const addedFileIndex = this.addedFiles.findIndex(f => f.name === removedFile.name && f.size === removedFile.size);
            if (addedFileIndex !== -1) {
                // Nếu có, xóa khỏi addedFiles
                this.addedFiles.splice(addedFileIndex, 1);
            } else {
                // Nếu không, thêm vào deletedFiles
                this.deletedFiles.push(removedFile);
            }

            this.emitChange();
            this.initializePopup();
        },

        emitChange() {
            // Truyền cả danh sách file hiện tại, file mới và file đã xóa lên component cha
            this.$emit('onChange', {
                files: this.files,
                addedFiles: this.addedFiles,
                deletedFiles: this.deletedFiles
            });
        },

        clearTempUrls() {
            this.files.forEach(file => {
                if (file.tempUrl) {
                    URL.revokeObjectURL(file.tempUrl);
                }
            });
        },

        initializePopup() {
            nextTick(() => {
                $('.popup-link').magnificPopup({
                    type: 'image',
                    gallery: { enabled: true }
                });
            });
        }
    },
    mounted() {
        this.files = this.initialValue.map(file => ({
            ...file,
            tempUrl: file.fileId ? null : this.createTempUrl(file),
        }));
        this.emitChange();
        this.initializePopup();
    },
    beforeUnmount() {
        this.clearTempUrls(); // Clear URLs when component unmounts to prevent memory leaks
    }
}
</script>

<style>
.image-thumb {
    max-width: 4em;
    max-height: 4em;
    vertical-align: middle;
    border-style: none;
    overflow: clip;
}

.mfp-bg,
.mfp-wrap {
    z-index: 1051 !important;
}

.list-files {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
}

.file-item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5em;
}

.image-thumb {
    margin-right: 0.5em;
    flex-shrink: 0;
}

.file-details {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5em;
    min-width: 0;
    /* Đảm bảo nội dung con không vượt quá parent */
    flex-grow: 1;
}

.file-actions {
    display: flex;
    gap: 0.5em;
    flex-wrap: wrap;
    align-items: center;
}

.text-primary {
    word-break: break-word;
    /* Ngắt từ khi dài quá */
    overflow-wrap: break-word;
    max-width: calc(100% - 4em);
    /* Tránh tràn ra ngoài */
}

.remove-icon {
    flex-shrink: 0;
    /* Đảm bảo icon không bị thu nhỏ */
    cursor: pointer;
}
</style>
